export const careOptions = {
	HouseVisit: "House Visit",
	Clinic: "Clinic",
	UrgentCare: "Urgent Care",
	EmergencyRoom: "Emergency Room",
	RetailClinic: "Retail Clinic",
	Telemedicine: "Telemedicine",
	NineOneOne: "Nine One One",
	ConciergeCare: "Concierge Care",
	Dental: "Dental",
	DeclineCare: "Decline Care",
	ExitTriage: "Exit Triage",
  MedicalFacility: "Medical Facility"
};
export const telemedicineVendors = {
	oneEightHundredMD : "1-800MD LLC",
	Semesur : "Semesur",
	Maple : "Maple",
	GPDQ : "GPDQ",
  MediOrbis : "MediOrbis",
  connectionTypeVideo : "2",
  connectionTypeAudio : "1",
}
export const applicationVersions = {
	TravelAid1 : "1",
	TravelAid2 : "2",
	FindFacility : "3"
}
export const symptomTypes = {
	RiskFactor : 1,
    LocationRiskFactor : 2,
    Symptom : 3,
    RedFlag : 4,
    Related : 5,
    Diagnosis : 6
};
export const genderConst = {
	Female :  "female" ,
    Male :  "male" 
};

export const apiLanguages = {
    english: 1,
    spanish: 2,
    german: 3,
    french: 4,
    englishUK: 5,
    hindi: 6,
  }  
  
  export const commonConstant = {
    success: "Success",
    true: true,
    Unknown:"Unknown",
    nullHours:"n",
    NoServiceAvailable:"No available services were found",
    PreLogin:"PreLogin",
    APIError:"APIError",
    orgSubscription: "orgSubscription",
    GEMName: "Global Excel Management",
    age:30,
    enLanguage: "en",
    locationTypeHouse : "1",
    locationTypeHotel : "2",
    locationTypeEmpty : "-1",
    USA: "USA"
  }